import { http } from '@/plugin/axios'
import { webinars } from '@/hard-data/webinars.js'

const state = {
  trainings: {
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 10,
      total: 6
    }
  },
  training: [],
  mainPageTraining: [],
  newTrainings: {
    data: webinars
  }
}
const getters = {
  getTrainings: (state) => state.trainings,
  getMainPageTrainings: (state) => state.mainPageTraining,
  getTraining: (state) => state.training,
  getNewTrainings: (state) => state.newTrainings
}
const actions = {
  async fetchTrainings({ commit }, { searchString, trainingType, page }) {
    return await http({
      url: `/frontend/library?per_page=4&search=${searchString}&type=${trainingType}&page=${page}`,
      method: 'get'
    }).then(({ data }) => {
      commit('setTrainings', data)
    })
  },
  async fetchTraining({ commit }, id) {
    // return await http({
    //   url: `/frontend/library/${id}`,
    //   method: 'get'
    // }).then(({ data }) => {
    //   commit('setTraining', data)
    // })

    const training = state.newTrainings.data.find((t) => t.id === parseInt(id))
    if (training) {
      commit('setTraining', { data: training })
      return Promise.resolve({ data: training })
    } else {
      return Promise.reject(new Error('Training not found'))
    }
  },
  async fetchMainPageTraining({ commit }, id) {
    // return await http({
    //   url: '/frontend/main-page-library',
    //   method: 'get'
    // }).then(({ data }) => {
    //   commit('setMainPageTraining', data)
    // })

    commit('setMainPageTraining', state.newTrainings)
    return Promise.resolve(state.newTrainings)
  }
}
const mutations = {
  setTrainings(state, trainingData) {
    state.trainings = trainingData.data
  },
  setTraining(state, trainingData) {
    state.training = trainingData.data
  },
  setMainPageTraining(state, trainingData) {
    state.mainPageTraining = trainingData.data
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
